import type { CardProps } from "@chakra-ui/react";
import { Card, HStack, Stack, Text } from "@chakra-ui/react";
import React from "react";

interface Props extends Omit<CardProps, "title"> {
  title: React.ReactNode;
  titleContent?: React.ReactNode;
}

export const OrderCard = ({
  title,
  titleContent,
  children,
  ...props
}: Props) => {
  return (
    <Card
      p="8"
      {...props}
      color="gray"
      width="340px"
      maxWidth="100%"
    >
      <Stack
        spacing="4"
        width="100%"
      >
        <HStack width="100%">
          <Text
            color="black"
            fontWeight="bold"
            flex="1"
          >
            {title}
          </Text>
          {titleContent}
        </HStack>
        <Stack spacing="5">{children}</Stack>
      </Stack>
    </Card>
  );
};
